<template>
  <v-row
    no-gutters
    class="leaderboard-row"
    :class="{ 'self': isSelf }"
    @click="$emit('open-user-lineup-dialog', userMegaLeague)"
  >
    <div class="leaderboard-rank">
      <span>{{ rank | rank }}</span>
    </div>
    <div class="flex-grow-1">
      <user-nickname-picture
        v-if="userMegaLeague.user"
        :user="userMegaLeague.user"
        picture-left
        disable-link
      />
    </div>
    <div class="leaderboard-score">
      <score
        :score="userMegaLeague.totalScore"
        :max-score="userMegaLeague.maxScore()"
      />
    </div>
  </v-row>
</template>

<script>
import UserNicknamePicture from '@/components/UserNicknamePicture.vue';
import Score from '@/components/Card/Score.vue';
import UserMegaLeague from '@/models/MegaLeague/userMegaLeague';

export default {
  name: 'LeaderboardRow',
  components: {
    UserNicknamePicture,
    Score,
  },
  props: {
    userMegaLeague: {
      type: UserMegaLeague,
      required: true,
    },
    isSelf: {
      type: Boolean,
      required: true,
    },
    rank: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.leaderboard-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 20px;
  margin: 8px 0;
}

.self {
  border: 2px solid white;
  border-radius: 7px;
  background-color: $background;
}

.leaderboard-rank {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  min-width: 80px;
}

.leaderboard-score {
  margin: 7px 0;
  text-align: center;
}
@media (max-width: 500px) {
  .leaderboard-rank {
    min-width: 30px;
  }
}
</style>
